{
  "defaultRegion": "MT",
  "regions": {
    "MT": {
      "name": "Montana",
      "stateCode": "MT",
      "offlineImageryBBox": {
        "minLon": -116.15,
        "minLat": 44.26,
        "maxLon": -104.04,
        "maxLat": 49.10
      },
      "mapView": {
        "defaultHome": {
          "lat": 46.6,
          "lng": -111.0
        },
        "mapDefaultZoom": 7,
        "waterDefaultZoom": 8
      },
      "pmtiles": {
        "masterPath": "/rails/storage/montana.pmtiles"
      }
    }
  }
}
